<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        class="ml-5"
        v-on="on"
        tile
        outlined
        color="primary"
        @click="$emit('lang')"
      >{{$t('Settings.editlang')}}</v-btn>
    </template>

    <v-card>
      <v-card-title class="title grey lighten-2" primary-title>{{$t('Settings.dialoglangtitle')}}</v-card-title>
      <v-card-text class="mt-5">
        <v-row align="center" justify="center">
          <template v-for="item in lang">
            <v-btn class="ma-2" x-large :key="item.lang" icon @click="changeLanguage(item.lang)">
              <flag style="font-size:25px" :iso="item.flag" v-bind:squared="false" />
            </v-btn>
          </template>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">{{$t('Settings.back')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    id: String,
    lang: Array
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    changeLanguage: function(lang) {
      axios
        .put(
          process.env.VUE_APP_API_ADDR + "/api/user/@me/lang",
          {
            lang: lang
          },
          {
            headers: { Authorization: tokenStore.getToken() }
          }
        )
        .then(res => {
          if (res.data.success) {
            this.$emit("saved", lang);
            this.dialog = false;
          }
        })
        .catch(err => {
          this.$emit("error", err.response.data.errorMessage);
        });
    }
  }
};
</script>


